import { ControllersData } from '@/logic/main/types';

type ComponentsEntry = [
  string,
  {
    type: string;
    properties: any;
  }
];

export enum controllersEnum {
  CATEGORIES = 'categories',
  PROMOTIONS = 'promotions',
  GAME_DETAILS = 'gameDetails',
  SEARCH = 'search',
  RECENTLY_PLAYED = 'recentlyPlayed',
  GAME_LAUNCHER = 'gameLauncher',
  SEARCH_BAR = 'searchBar',
  SEARCH_DESKTOP = 'searchDesktopWrapper',
  BINGO_GAMES = 'bingoGames',
  DYNAMIC_ROUTE_ACTION = 'dynamicRouteAction',
  VIDEO_MODAL = 'videoModal',
  CATEGORY_DETAILS = 'categoryDetails',
}

export const ALL_CONTROLLERS = Object.values(controllersEnum);

export const controllersComponentsMapper = {
  [controllersEnum.CATEGORIES]: [
    'Banner',
    'GameBanner',
    'GameDual',
    'GameGrid',
    'Category',
    'GameCollection',
    'JackpotGrid',
  ],
  [controllersEnum.VIDEO_MODAL]: ['VideoModal'],
  [controllersEnum.GAME_DETAILS]: ['GameDetailsModal'],
  [controllersEnum.RECENTLY_PLAYED]: ['RecentlyPlayed'],
  [controllersEnum.SEARCH]: [
    'SearchHeader',
    'SearchCategory',
    'SearchHistory',
    'SearchMoreResults',
  ],
  [controllersEnum.PROMOTIONS]: ['PromotionsBasecamp'],
  [controllersEnum.GAME_LAUNCHER]: ['GameLauncher'],
  [controllersEnum.SEARCH_BAR]: ['SearchBar'],
  [controllersEnum.SEARCH_DESKTOP]: ['SearchDesktopWrapper'],
  [controllersEnum.BINGO_GAMES]: ['BingoGames'],
  [controllersEnum.DYNAMIC_ROUTE_ACTION]: ['DynamicRouteAction'],
  [controllersEnum.CATEGORY_DETAILS]: ['CategoryDetails'],
};

const isExpectedController = (
  controllerName: string,
  expectedController: string
) => controllerName.includes(expectedController);

export const removeSpecificControllers = (
  controllersData: ControllersData,
  controllersToRemove: string[]
): ControllersData => {
  return Object.entries(controllersData).reduce((acc, [key, value]) => {
    const data = value.components.filter(([key]: [string]) =>
      controllersToRemove.some(
        cToRemove => !isExpectedController(key, cToRemove)
      )
    );

    return {
      ...acc,
      ...(data ? { [key]: { components: data } } : {}),
    };
  }, {});
};

export const extractControllersData = (
  componentsEntries: ComponentsEntry[]
): ControllersData => {
  const data: any = {};

  ALL_CONTROLLERS.forEach((controllerName: controllersEnum) => {
    const controllerComponentNames =
      controllersComponentsMapper[controllerName];

    const controllerData = extractData(
      componentsEntries,
      controllerComponentNames
    );

    if (controllerData) {
      data[controllerName] = controllerData;
    }
  });

  return data;
};

function extractData(
  componentsEntries: ComponentsEntry[],
  controllerComponentTypes: string[]
) {
  const acceptableComponents = componentsEntries.filter(([id, entry]) =>
    controllerComponentTypes.includes(entry.type)
  );

  if (acceptableComponents.length === 0) {
    return null;
  }
  return {
    components: acceptableComponents,
  };
}
